import type { TRuleWithTheme } from '@/styles/theme';

export const text: TRuleWithTheme = () => ({
    marginBottom: '0.75rem',

    fontSize: '0.875rem',
    lineHeight: '1.25rem',
});
